import { render, staticRenderFns } from "./ListDefault.vue?vue&type=template&id=43d38920"
import script from "./ListDefault.vue?vue&type=script&lang=ts"
export * from "./ListDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports